import { Card, Space, Button } from 'antd';
import { VideoCameraOutlined, ReloadOutlined } from '@ant-design/icons';
import { useUnifiedDashboardStore } from '../../store';
import VideoRoomPanel from './VideoRoomPanel';

const MonitorPage = () => {
  const { isFetchingTaskRouter, fetchTaskRouterOnly } =
    useUnifiedDashboardStore();

  return (
    <div style={{ padding: '16px' }}>
      <Card
        size="default"
        title={
          <Space>
            <VideoCameraOutlined />
            Video Rooms
          </Space>
        }
        extra={
          <Button
            icon={<ReloadOutlined />}
            onClick={fetchTaskRouterOnly}
            loading={isFetchingTaskRouter}
            size="default"
          >
            Refresh
          </Button>
        }
        styles={{ body: { padding: 0 } }}
      >
        <VideoRoomPanel />
      </Card>
    </div>
  );
};

export default MonitorPage;
